module.exports = __webpack_public_path__ + "static/paystack-suported-currency-e12dd7b9a448eb8c459f4d3631dd1f19.png";